module.exports = __webpack_public_path__ + "img/recycle.bf16f6c.svg";